import React from 'react';
import { TrophyIcon, CheckCircle2Icon, GlobeIcon, ShieldCheckIcon } from 'lucide-react';
import { CtaButton } from '../CtaButton';
import { Countdown } from '../Countdown';
import { ScarcityBar } from '../ScarcityBar';
import { images } from '../../data/landing';
const perks = ['One-Time Payment', 'Lifetime Access', 'No Monthly Fees', 'Instant Digital Access'];
export function Offer() {
  return <section id="offer" className="bg-cream px-3 py-16 sm:px-5 sm:py-24" aria-labelledby="offer-title" data-id="element-173" data-mp="3a68htmqiw8a3">
      <div className="mx-auto max-w-xl overflow-hidden rounded-[2rem] bg-white shadow-[0_24px_60px_-20px_rgba(6,15,31,0.35)] ring-2 ring-brand-500" data-id="element-174" data-mp="3f3i4wvqfw7ur">
        <div className="bg-navy-900 px-6 py-7 text-center text-white" data-id="element-175" data-mp="3jxmcnh7j4jww">
          <span className="inline-flex items-center gap-2 rounded-full bg-ember-500 px-4 py-1.5 text-sm font-extrabold uppercase tracking-wide" data-id="element-176" data-mp="3nwc0y4u3vlvb">
            <TrophyIcon className="h-4 w-4" aria-hidden="true" data-id="element-177" data-mp="1pdr15n02ecd" />
            Special launch offer
          </span>
          <h2 id="offer-title" className="mt-4 text-balance font-display text-[1.9rem] font-black leading-tight sm:text-4xl" data-id="element-178" data-mp="1klzv1daenumt">
            Here’s Everything You’ll Receive Today
          </h2>
        </div>

        <div className="px-5 pb-8 pt-6 sm:px-8" data-id="element-179" data-mp="1bk0boebx4egp">
          <img src={images.mockup} alt="" className="mx-auto w-full" data-id="element-180" data-mp="1bmwae4vlb767" />

          <dl className="mt-6 divide-y divide-navy-900/10 border-y border-navy-900/10" data-id="element-181" data-mp="16n0dsqp82i0o">
            <div className="flex items-center justify-between gap-4 py-4" data-id="element-182" data-mp="23awo5du2gh3g">
              <dt data-id="element-183" data-mp="1z9unqtoexyzw">
                <p className="font-extrabold text-navy-900" data-id="element-184" data-mp="1zbfj2lijxlyt">Hernia Clinical Playbook™</p>
                <p className="text-sm text-navy-900/65" data-id="element-185" data-mp="1uiuovivqh6ur">6 Premium Volumes</p>
              </dt>
              <dd className="font-bold text-navy-900/60 line-through" data-id="element-186" data-mp="1plcqgmfcea10">$147</dd>
            </div>
            <div className="flex items-center justify-between gap-4 py-4" data-id="element-187" data-mp="2n0gri8rdwx43">
              <dt data-id="element-188" data-mp="2i98mrq101zx9">
                <p className="font-extrabold text-navy-900" data-id="element-189" data-mp="2i8p0xy88ardy">5 Exclusive Bonuses</p>
                <p className="text-sm text-navy-900/65" data-id="element-190" data-mp="315qx811va33f">Cases, checklists, scripts & more</p>
              </dt>
              <dd className="font-bold text-navy-900/60 line-through" data-id="element-191" data-mp="3653jokott85h">$197</dd>
            </div>
            <div className="flex items-center justify-between gap-4 py-4" data-id="element-192" data-mp="2sdfaoq9vizsq">
              <dt className="font-black uppercase tracking-wide text-navy-900" data-id="element-193" data-mp="2sbchxyhc6skb">Total value</dt>
              <dd className="text-xl font-black text-alert-600 line-through" data-id="element-194" data-mp="2wce8lqx6twao">$344</dd>
            </div>
          </dl>

          <div className="mt-6 text-center" data-id="element-195" data-mp="2ndsv4a6kp7gr">
            <p className="text-base text-navy-900/75" data-id="element-196" data-mp="2nevnkmjjnhys">Today, you can get complete access for just…</p>
            <p className="mt-1 font-display text-[5.5rem] font-black leading-none text-navy-900 sm:text-8xl" data-id="element-197" data-mp="29fvw774ncoyx">
              <span className="align-top text-4xl" data-id="element-198" data-mp="2dg6e9i5pr5u5">$</span>27
            </p>
            <p className="mt-2 flex items-center justify-center gap-1.5 text-sm font-semibold text-brand-700" data-id="element-199" data-mp="7o9ddsuws0dj">
              <GlobeIcon className="h-4 w-4 shrink-0" aria-hidden="true" data-id="element-200" data-mp="bnzzhj9hpsbq" />
              Automatic currency conversion for your country
            </p>
          </div>

          <ul className="mt-6 grid grid-cols-2 gap-2.5" data-id="element-201" data-mp="1s5rym3zc3gls">
            {perks.map(perk => <li key={perk} className="flex items-center gap-2 rounded-xl bg-brand-50 px-3 py-2.5 text-sm font-bold text-navy-900" data-id="element-202" data-mp="25wx59q14d95m">
                <CheckCircle2Icon className="h-4 w-4 shrink-0 text-cta-500" aria-hidden="true" data-id="element-203" data-mp="2fujnomhmniuc" />
                {perk}
              </li>)}
          </ul>

          <p className="mt-6 text-center text-base leading-relaxed text-navy-900/75" data-id="element-204" data-mp="2av7182uo4dsa">
            For less than the cost of a typical professional consultation, you can have a structured clinical
            reference system you can keep and return to whenever you need it.
          </p>

          <div className="mt-6" data-id="element-205" data-mp="uhqig6dnf8i0">
            <ScarcityBar data-id="element-206" data-mp="pi5a55cl9nsm" />
          </div>

          <CtaButton className="mt-6" label="Get the Hernia Clinical Playbook™" sublabel="One-time payment of $27 · Instant Access · 7-Day Guarantee" data-id="element-207" data-mp="pj6ww72yvyq6" />

          <Countdown data-id="element-208" data-mp="vxcjy2j4t82l" />

          <div className="mt-6 space-y-2 border-t border-navy-900/10 pt-5 text-center text-sm text-navy-900/70" data-id="element-209" data-mp="vwkl8iu8mu83">
            <p className="flex items-center justify-center gap-1.5" data-id="element-210" data-mp="10vdxk7xsgf6o">
              <GlobeIcon className="h-4 w-4 shrink-0" aria-hidden="true" data-id="element-211" data-mp="15v8tipwf7uyl" />
              Currency conversion is automatically adjusted according to your country.
            </p>
            <p className="flex items-center justify-center gap-1.5" data-id="element-212" data-mp="d74l3wmgt3s7">
              <ShieldCheckIcon className="h-4 w-4 shrink-0 text-cta-600" aria-hidden="true" data-id="element-213" data-mp="i6zatwui7nbo" />
              Secure checkout · 7-day satisfaction guarantee
            </p>
          </div>
        </div>
      </div>
    </section>;
}